import { IRequesterInfo } from '../../../base/models'
import { ClientProxy } from '../../../base/proxy/clientProxy'
import { CompayBankInfo } from '../models/models'
import * as ServiceProxy from '../../../base/proxy/serviceProxy'
import { ServiceCallTypeEnum } from '../../../base/models'

interface CompayBankApiResponse {
  acquirerId: string
  bankName: string
  bankLogo: string
}

interface CompayBankListResponse {
  success: boolean
  data: CompayBankApiResponse[]
  message: string
}

export class GetCompayBankListApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'compay-payment/shop-credit-banks',
      requesterInfo,
    })
  }

  async getBankList(): Promise<CompayBankInfo[]> {
    try {
      // Direct call to ServiceProxy to bypass the standard Data wrapper
      const response = await ServiceProxy.Call<any>(ServiceCallTypeEnum.Get, 'GetCompayBankList', this.props)

      // The actual response is directly in response.data (not response.data.Data)
      const bankListResponse = response.data as CompayBankListResponse

      // Check if response is successful and has data
      if (!bankListResponse || !bankListResponse.success || !Array.isArray(bankListResponse.data)) {
        return []
      }

      // API'den gelen veriyi frontend formatına çevir
      const bankList: CompayBankInfo[] = bankListResponse.data.map(bank => ({
        id: bank.acquirerId,
        name: bank.bankName,
        logo: bank.bankLogo,
        acquirerIds: {
          ALISVERIS_KREDISI: bank.acquirerId,
          ANINDA_HAVALE: '',
          MOBIL_CUZDAN: '',
        },
      }))

      return bankList
    } catch (error) {
      console.error('Error fetching bank list:', error)
      return []
    }
  }
}
